import { render, staticRenderFns } from "./AnnotationDurationHelper.vue?vue&type=template&id=264647b0&scoped=true"
import script from "./AnnotationDurationHelper.vue?vue&type=script&lang=ts"
export * from "./AnnotationDurationHelper.vue?vue&type=script&lang=ts"
import style0 from "./AnnotationDurationHelper.vue?vue&type=style&index=0&id=264647b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264647b0",
  null
  
)

export default component.exports